import CONFIG from '@/config'
import { useLoginStatus } from '@/utils/useStore'

export default {
  data() {
    return {
      CONFIG,
      menuVisible: false,
      timer: null,
      vipSupportEmail: '',
      wxQrcodeShow: false
    }
  },
  computed: {
    show() {
      const path = this.$route.path
      if (path == '/') return true
      if (useLoginStatus()) return false
      return true
    }
  },
  methods: {
    fadeOutMenu() {
      this.timer = setTimeout(() => {
        this.menuVisible = false
      }, 2000)
    },
    clearTimer() {
      clearTimeout(this.timer)
      this.timer = null
    },
    goLogin() {
      this.$router.push({ path: '/user/login' })
    },
    hideWxBox($event) {
      const target = $event.target
      if (target.getAttribute('id') == 'wechat') return
      this.wxQrcodeShow = false
    }
  },
  created() {
    const locale = this.$i18n.locale
    if (locale == 'ja-jp') {
      this.vipSupportEmail = CONFIG.CONTACTUS_JP_EMAIL
    } else if (locale == 'ko-kr') {
      this.vipSupportEmail = CONFIG.CONTACTUS_KR_EMAIL
    } else {
      this.vipSupportEmail = CONFIG.CONTACTUS_EMAIL
    }
  },
  mounted() {
    document.addEventListener('click', this.hideWxBox)
  },
  destroyed() {
    document.removeEventListener('click', this.hideWxBox)
  }
}
